import { useState } from 'react';
import { Form } from 'antd';
import { useCreateOccupationalDoctor, useGetListOccupationalDoctor } from '@/hooks/v2/occupational-doctor';

const { useWatch } = Form;

interface MedicineServiceResponsibleProps {
	fieldName?: string | string[];
}

export function useMedicineServiceResponsible({ fieldName }: MedicineServiceResponsibleProps) {
	const field = Array.isArray(fieldName) ? fieldName[0] : null;
	const [name, setName] = useState<string>('');

	const organization_id = useWatch(field ? [field, 'organization_id'] : 'organization_id');
	const company_id = useWatch(field ? [field, 'company_id'] : 'company_id');

	const { isLoading, data: occupationalDoctors } = useGetListOccupationalDoctor({
		organization_id,
		company_id
	});

	const { mutate: createOccupationalDoctor } = useCreateOccupationalDoctor();

	function handleInputChange(event: React.ChangeEvent<HTMLInputElement>): void {
		setName(event.target.value);
	}

	function addItem(e: React.MouseEvent<HTMLAnchorElement>): void {
		e.preventDefault();

		if (!name.trim()) {
			return;
		}

		createOccupationalDoctor({
			name: name.trim(),
			company_id,
			organization_id
		});
	}

	function handleSearch(value: string): void {
		if (value.length > 2) {
		}
	}

	const data =
		occupationalDoctors && occupationalDoctors.rows
			? occupationalDoctors.rows.map((item) => ({
					label: item.name,
					value: item.id
				}))
			: [];

	return { isLoading, data, addItem, handleSearch, handleInputChange };
}
